import { postRequest } from 'config/Axios/baseConfig';
import { VisibilityBoardError, VisibilityBoardResponseSchema } from 'Interfaces/VisibilityBoard';

export const VisibilityBoardServices = {
  getVisibilityBoardData: (payload: {
    room: string;
    shift: string;
  }): Promise<VisibilityBoardResponseSchema | VisibilityBoardError> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<VisibilityBoardResponseSchema | VisibilityBoardError>(
          'pps/get-visibility-board/',
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
